'use client'

import { Button } from '@heroui/react'
import Link from 'next/link'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Article page error:', error)
  }, [error])

  // Determine if error is related to comments or article
  const isCommentError = error.message?.toLowerCase().includes('comment')
  const title = isCommentError ? 'Comment Error' : 'Article Error'
  const message = error.message || (isCommentError
    ? 'Failed to load comments. Please try again.'
    : 'Failed to load the article. Please try again.')

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-4">
      <div className="text-center space-y-4">
        <h2 className="text-2xl font-bold text-danger">{title}</h2>
        <p className="text-default-600">{message}</p>
        <div className="flex gap-4 justify-center">
          <Button
            onPress={() => reset()}
          >
            Try again
          </Button>
          <Link href="/articles" className="inline-flex no-underline">
            <Button
              variant="outline"
            >
              Back to Articles
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
